import styled from 'styled-components';
import PropTypes from 'prop-types';
import React, { memo, useEffect } from 'react';
import sizes from 'styles/sizes';

const Container = styled.div`
  position: relative;
  width: 100%;
  min-width: 300px;
  margin: 30px auto 0px;

  @media (min-width: ${sizes.media.mediumMaxWidth}px) {
    max-width: 1220px;
    margin: ${props =>
      props.isMoreButtonPresent ? '30px auto 20px' : '50px auto 20px'};
  }
`;

function EmbeddedSurvey({ surveyId, isMoreButtonPresent }) {
  useEffect(() => {
    if (window.KAMPYLE_ONSITE_SDK && typeof window.KAMPYLE_ONSITE_SDK.rcgUpdatePageView === 'function') {
      window.KAMPYLE_ONSITE_SDK.rcgUpdatePageView();
    }
  }, []);

  return (
    <Container
      id={surveyId}
      isMoreButtonPresent={isMoreButtonPresent}
    ></Container>
  );
}

EmbeddedSurvey.propTypes = {
  surveyId: PropTypes.string,
  isMoreButtonPresent: PropTypes.bool,
};

export default memo(EmbeddedSurvey);
